import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../Api/CommonApi";
import { api } from "../../Api/AuthApi";

export const create_policy = createAsyncThunk(
    "create_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.create_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_policy = createAsyncThunk(
    "update_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.update_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_all_policy = createAsyncThunk(
    "get_all_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.get_all_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const active_inActive_policy = createAsyncThunk(
    "active_inActive_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.active_inActive_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);


export const get_policy_by_code = createAsyncThunk(
    "get_policy_by_code",
    async (id: string, { rejectWithValue }) => {
        return await ApiGetNoAuth(`${api.get_policy_by_code}/${id}`)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => rejectWithValue(err));
    }
);

export const create_mail_template = createAsyncThunk(
    "create_mail_template",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.create_mail_template, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_mail_template = createAsyncThunk(
    "update_mail_template",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.update_mail_template, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_all_mail_template = createAsyncThunk(
    "get_all_mail_template",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.get_all_mail_template, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_mail_template_by_id = createAsyncThunk(
    "get_mail_template_by_id",
    async (id: string, { rejectWithValue }) => {
        return await ApiGetNoAuth(`${api.get_mail_template_by_id}/${id}`)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => rejectWithValue(err));
    }
);

export const send_template_mail = createAsyncThunk(
    "send_template_mail",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.send_template_mail, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const create_notification_template = createAsyncThunk(
    "create_notification_template",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.create_notification_template, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_notification_template = createAsyncThunk(
    "update_notification_template",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.update_notification_template, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_all_notification_template = createAsyncThunk(
    "get_all_notification_template",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.get_all_notification_template, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_notification_template_by_id = createAsyncThunk(
    "get_notification_template_by_id",
    async (id: string, { rejectWithValue }) => {
        return await ApiGetNoAuth(`${api.get_notification_template_by_id}/${id}`)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => rejectWithValue(err));
    }
);

export const send_template_notification = createAsyncThunk(
    "send_template_notification",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.send_template_notification, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const create_imp_link = createAsyncThunk(
    "create_imp_link",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.create_imp_link, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_imp_link = createAsyncThunk(
    "update_imp_link",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.update_imp_link, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_all_imp_link = createAsyncThunk(
    "get_all_imp_link",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.get_all_imp_link, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_imp_link_by_id = createAsyncThunk(
    "get_imp_link_by_id",
    async (id: string, { rejectWithValue }) => {
        return await ApiGetNoAuth(`${api.get_imp_link_by_id}/${id}`)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => rejectWithValue(err));
    }
);